"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCart_jericho = exports.addItem_jericho = void 0;
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../../../API/BaseApi"));
var index_1 = require("../../common/index");
var index_2 = require("../../../Config/index");
var interfaces_1 = require("../interfaces");
function addItem_jericho(cartId, addItems, hostAnnotations) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var params, responseParams, response;
        return tslib_1.__generator(this, function (_a) {
            params = {
                data: tslib_1.__assign({ items: addItems }, (hostAnnotations && { hostAnnotations: hostAnnotations })),
                command: 'addItemToCart',
                productType: addItems[0].productType,
                cartId: cartId,
            };
            responseParams = BaseApi_1.default.doPostRequestToChegg(index_2.sibcV2Url, params, null, interfaces_1.ADDITEM_TIMEOUT);
            response = (0, index_1.postRequestToCheggResponse)(responseParams);
            return [2 /*return*/, response];
        });
    });
}
exports.addItem_jericho = addItem_jericho;
// jericho calls are deprecated. Not worth adding unittests for this anymore. Should create ticket to remove unused jericho integration.
/* istanbul ignore next */
function updateCart_jericho(cartId, items, payment, hostAnnotations, doAdditionalAddressValidation) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var params, responseParams;
        return tslib_1.__generator(this, function (_a) {
            doAdditionalAddressValidation = doAdditionalAddressValidation !== null && doAdditionalAddressValidation !== void 0 ? doAdditionalAddressValidation : true;
            params = {
                data: {
                    items: items,
                    billing: payment === null || payment === void 0 ? void 0 : payment.billingAddress,
                    payment: payment,
                    doAdditionalAddressValidation: doAdditionalAddressValidation,
                },
                command: 'billingPaymentInfo',
                productType: items && items[0].productType,
                cartId: cartId,
            };
            responseParams = BaseApi_1.default.doPostRequestToChegg(index_2.sibcV2Url, params, null, interfaces_1.ADDITEM_TIMEOUT);
            return [2 /*return*/, (0, index_1.postRequestToCheggResponse)(responseParams)];
        });
    });
}
exports.updateCart_jericho = updateCart_jericho;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/cartAPI/jericho/index.js
// module id = 3385
// module chunks = 11